// extracted by mini-css-extract-plugin
module.exports = {"avatar":"AccountMenu_avatar__222Ls","menu":"AccountMenu_menu__1n8fn"};